/**
 * @module RainbowSDK
 */

import { stringify } from 'flatted';

export class RBEvent<TEventName extends string = string, TData = any> {
    /** @internal */
    private constructor(name: TEventName, data: TData) {
        this.name = name;
        this.data = data;
    }

    public static create<TEventName extends string>(name: TEventName): RBEvent<TEventName, undefined>;
    public static create<TEventName extends string, TData>(name: TEventName, data: TData): RBEvent<TEventName, TData>;
    public static create<TEventName extends string, TData>(name: TEventName, data?: TData): RBEvent<TEventName, TData | undefined> {
        return new RBEvent<TEventName, TData | undefined>(name, data);
    }

    public name: TEventName;
    public data: TData;

    /** @internal */
    public toString(): string {
        return `${this.name as string} ${stringify(this.data)}`;
    }
}
